export interface Testimonial {
  id: string;
  name: string;
  username: string;
  rating: number;
  text: string;
}

export const testimonials: Testimonial[] = [
  {
    id: 't1',
    name: 'Lucas M.',
    username: '@lucasm_street',
    rating: 5,
    text: 'Encontrei os melhores tênis em poucos minutos. A planilha CSSBuy é incrivelmente organizada e me economizou horas de pesquisa.',
  },
  {
    id: 't2',
    name: 'Beatriz R.',
    username: '@bea_fashion',
    rating: 5,
    text: 'Muito mais fácil que procurar sozinho. Os links são verificados e sempre atualizados. Recomendo para todo mundo que compra no CSSBuy.',
  },
  {
    id: 't3',
    name: 'Gabriel S.',
    username: '@gabriel_sneak',
    rating: 5,
    text: 'Planilhas sempre atualizadas com os melhores produtos. Encontrei peças que nunca teria achado sozinho. Vale muito a pena.',
  },
  {
    id: 't4',
    name: 'Mariana C.',
    username: '@mari_style',
    rating: 5,
    text: 'A melhor planilha CSSBuy que já usei. Interface limpa, categorias bem organizadas e produtos de qualidade. Simplesmente perfeito.',
  },
  {
    id: 't5',
    name: 'Pedro H.',
    username: '@pedro_fits',
    rating: 5,
    text: 'Compro no CSSBuy há 2 anos e essa planilha mudou completamente minha experiência. Economia de tempo absurda.',
  },
  {
    id: 't6',
    name: 'Ana L.',
    username: '@ana_haul',
    rating: 5,
    text: 'Finalmente uma planilha CSSBuy em português com produtos que realmente valem a pena. Links verificados e atualização constante.',
  },
];

export interface ComparisonData {
  platform: string;
  facilidade: number;
  preco: number;
  frete: number;
  highlight?: boolean;
}

export const comparisonData: ComparisonData[] = [
  { platform: 'CSSBuy', facilidade: 5, preco: 4, frete: 4, highlight: true },
  { platform: 'Superbuy', facilidade: 3, preco: 3, frete: 3 },
  { platform: 'Mulebuy', facilidade: 3, preco: 3, frete: 3 },
  { platform: 'Outros', facilidade: 2, preco: 2, frete: 2 },
];

export const faqItems = [
  {
    question: 'O que é um CSSBuy Spreadsheet?',
    answer: 'Um CSSBuy Spreadsheet é uma planilha organizada com links diretos para produtos verificados disponíveis no CSSBuy. Ela reúne os melhores achados de tênis, roupas, acessórios e streetwear, economizando horas de pesquisa manual. Nossa planilha é atualizada diariamente com novos produtos e links verificados pela nossa equipe.',
  },
  {
    question: 'O CSSBuy é seguro para comprar?',
    answer: 'Sim, o CSSBuy é uma plataforma segura que oferece fotos QC (Quality Check), proteção ao comprador, seguro de encomendas e sistema de reembolso. Milhares de usuários no Brasil e no mundo confiam no CSSBuy para suas compras internacionais. Nossa planilha inclui apenas links de vendedores verificados.',
  },
  {
    question: 'Como usar o CSSBuy Spreadsheet?',
    answer: 'Basta acessar nossa planilha, navegar pelas categorias de produtos, clicar nos links que você gostar e será redirecionado diretamente para o produto no CSSBuy. É simples, rápido e organizado. Você pode filtrar por marca, tipo de produto ou preço para encontrar exatamente o que procura.',
  },
  {
    question: 'Com que frequência a planilha é atualizada?',
    answer: 'Nossa planilha CSSBuy é atualizada diariamente com novos produtos, links verificados e as melhores ofertas. Mantemos uma equipe dedicada que busca constantemente os melhores achados em todas as categorias — de tênis a acessórios.',
  },
  {
    question: 'Quanto custa o frete internacional no CSSBuy?',
    answer: 'O frete internacional no CSSBuy varia conforme o peso, destino e método de envio escolhido. O CSSBuy oferece múltiplas opções de transporte com preços competitivos. Na nossa planilha, você encontra produtos com excelente relação custo-benefício, incluindo opções leves que reduzem o custo do frete.',
  },
  {
    question: 'Posso devolver produtos comprados pelo CSSBuy?',
    answer: 'Sim, o CSSBuy possui um sistema de reembolso e devolução. Caso o produto chegue com defeito ou diferente do anunciado, você pode solicitar reembolso. As fotos QC ajudam a verificar a qualidade antes do envio internacional, reduzindo a necessidade de devoluções.',
  },
  {
    question: 'A planilha funciona para iniciantes no CSSBuy?',
    answer: 'Absolutamente! Nossa planilha foi projetada tanto para iniciantes quanto para compradores experientes. As categorias são intuitivas, os links são diretos e você não precisa de conhecimento técnico para usar. Se você está começando no CSSBuy, nossa planilha é o melhor ponto de partida.',
  },
  {
    question: 'Quais marcas estão disponíveis na planilha?',
    answer: 'Nossa planilha inclui produtos das marcas mais procuradas: Nike, Jordan, Adidas, Yeezy, Essentials, Fear of God, Supreme, Balenciaga, e muitas outras. Cobrimos desde streetwear acessível até peças de luxo, sempre com links verificados e produtos de qualidade.',
  },
  {
    question: 'O CSSBuy Spreadsheet é gratuito?',
    answer: 'Sim, nosso CSSBuy Spreadsheet é completamente gratuito. Acreditamos que informação de qualidade deve ser acessível a todos. Basta acessar, navegar pelas categorias e clicar nos produtos que você quiser — sem custo algum.',
  },
  {
    question: 'Como posso encontrar réplicas de qualidade no CSSBuy?',
    answer: 'Nossa planilha destaca os melhores vendedores e produtos com melhor avaliação no CSSBuy. Focamos em qualidade e precisão, selecionando apenas itens com boas fotos QC e feedback positivo da comunidade. Isso garante que você encontre produtos com ótimo acabamento e fidelidade ao original.',
  },
];